import React, { useState, useEffect } from 'react'
import { Form, Alert, Box, Button } from '@smooth-ui/core-sc'
import useInputValue from '@rehooks/input-value'
import { injectStripe } from 'react-stripe-elements'
import { validate } from 'email-validator'

import { FormField, SpinnerButton, GrayBox, P } from 'components/Elements/index'
import CardElement from 'components/Elements/CardElement'
import config from 'config'
import { useStripePayload } from 'helpers/StripeWrapper'

const SignupForm = ({
  stripe,
  onSubmit,
  error,
  loading,
  payload,
  onComplete,
  title,
  children,
  elements,
  clientSecret
}) => {
  const [paymentError, setPaymentError] = useState(null)
  const [innerLoading, setInnerLoading] = useState(false)
  const given_name = useInputValue('')
  const family_name = useInputValue('')
  const email = useInputValue('')
  const password = useInputValue('')
  useEffect(() => {
    if (error) {
      console.log('error')
      setInnerLoading(false)
    }
  }, [error, setInnerLoading])
  useEffect(() => {
    if (loading) {
      // Turn off innerloading
      setInnerLoading(false)
    }
  }, [loading, setInnerLoading])
  const onSubmitForm = async event => {
    event.preventDefault()
    if (innerLoading || loading) {
      return
    }
    console.log('submit', innerLoading, loading)
    setInnerLoading(true)
    const values = {
      given_name: given_name.value.trim(),
      family_name: family_name.value.trim(),
      email: email.value.trim(),
      password: password.value.trim()
    }
    let hasInputError = false
    Object.keys(values).forEach(k => {
      const value = values[k]
      if (!value || value.length < 2) {
        hasInputError = k
      }
    })
    if (!validate(values.email)) {
      setInnerLoading(false)
      return setPaymentError('Du har ikke fylt ut en gyldig e-post adresse')
    }
    if (hasInputError) {
      setInnerLoading(false)
      return setPaymentError('Ikke alle feltene er fylt ut riktig')
    }
    const cardElement = elements.getElement('card')
    const {
      setupIntent,
      error: paymentMethodError
    } = await stripe.confirmCardSetup(clientSecret, {
      payment_method: {
        card: cardElement,
        billing_details: {
          name: `${values.given_name} ${values.family_name}`,
          email: values.email
        }
      }
    })
    if (!setupIntent) {
      setInnerLoading(false)
      return setPaymentError('Du må legge inn kort-informasjon')
    }
    if (paymentMethodError) {
      setInnerLoading(false)
      return setPaymentError(paymentMethodError.message)
    }
    onSubmit({
      ...values,
      payment_method: setupIntent.payment_method
    })
  }
  const { error: payloadError, run } = useStripePayload({
    payload,
    stripe,
    onComplete
  })
  useEffect(() => {
    if (payload && !payload.payment_intent && !payload.setup_intent) {
      onComplete()
    }
  }, [onComplete, payload])
  const allError = error || paymentError
  const allLoading = innerLoading || loading
  const formProcessing = allError ? false : allLoading || !!payload
  return (
    <Box>
      {allError && <Alert variant="danger">{allError}</Alert>}
      {payloadError && (
        <div style={{ paddingTop: '1rem' }}>
          <P>Kunne ikke godkjenne ditt kort</P>
          <Button variant="primary" onClick={run}>
            Forsøk igjen
          </Button>
        </div>
      )}
      <GrayBox>
        {title}
        <Form onSubmit={onSubmitForm} mb={2}>
          <FormField
            name="given_name"
            placeholder="Fornavn"
            field={given_name}
            autoComplete="shipping given-name"
          />
          <FormField
            name="family_name"
            placeholder="Etternavn"
            field={family_name}
            autoComplete="shipping family-name"
          />
          <FormField
            name="email"
            placeholder="E-post"
            inputMode="email"
            field={email}
            autoComplete="email"
            autoCapitalize="none"
          />
          <FormField
            name="password"
            placeholder="Passord"
            type="password"
            field={password}
            autoComplete="current-password"
            autoCapitalize="none"
          />
          <Box mb={3}>
            <CardElement />
          </Box>
          {children}
          <SpinnerButton
            working={formProcessing}
            type="submit"
            text="Registrer deg"
            width="100%"
            scale="lg"
          />
        </Form>
      </GrayBox>
      <Box display="flex" alignItems="center">
        <img src="/imgs/powered_by_stripe.svg" alt="" />
        <Box
          as="span"
          fontSize="0.8rem"
          color="gray"
          ml="0.5rem"
          display="inline-block"
        >
          {config.appName} lagrer kortinformasjon sikkert hos Stripe.com i
          henhold til PCI DSS Level 1 certification
        </Box>
      </Box>
    </Box>
  )
}

export default injectStripe(SignupForm)
